// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 183) return "static/chunks/183-778d4c81ab7d4532.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"c3f30c50715e5fc5","205":"67e56ec58883c7b0","319":"0cbc2894a3f1b950","340":"e4d500dbd5ee8900","367":"223968490054aab4","639":"dc3bc98ad9ac5586","748":"748e2042faf5bbf4"}[chunkId] + ".js";
};